import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the React shared list remote flag is ENABLED.
 * Used for the remote-buyers sharedlist route.
 * If this guard returns false, the legacy Angular SharedlistsComponent (without a guard) serves
 * the path unchanged — no deploy needed for rollback.
 *
 * canMatch, not canActivate: LaunchDarklyUserGuard.canActivate redirects the browser when a
 * flag is off rather than resolving false, and canActivate does not fall through to the next
 * route entry at the same path regardless. Only canMatch gives flag-off rollback with no deploy.
 */
export const sharedlistReactGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('buy-sharedlist-enableReact');
};
